import axios from 'axios'

import config from '../../config'

const createActivityLog = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/ActivityLogs`
  return axios.post(url, data)
}

export default createActivityLog
